export default __webpack_public_path__ + "static/media/HiTNano-logo-2021.45aa6efe.svg";